module.exports = __webpack_public_path__ + "static/media/sync.432d05a9.svg";